import * as React from "react"

import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import Menu from "@mui/material/Menu"
import MenuItem from "@mui/material/MenuItem"
import { alpha } from "@mui/material/styles"
import { styled } from "@mui/system"
import { CancelButton, Icons } from "@src/components"
import { useTranslation } from "react-i18next"

const FilterButton = styled(CancelButton)({
  fontSize: 12,
  lineHeight: "20px",
  fontWeight: 500,
  borderWidth: "1.5px !important",
  color: alpha("#434343", 1),
  borderColor: alpha("#434343", 0.7),
  "&:hover, &.active": {
    color: alpha("#434343", 1),
    borderColor: alpha("#434343", 1),
    backgroundColor: "#F6F6F6"
  }
})

const StyledItem = styled(MenuItem)(({ selected }) => ({
  padding: "12px 16px",
  fontSize: 12,
  color: "#141414",
  alignItems: "center",
  borderBottom: "1px solid #E6E6E6",
  "&:hover, &.active": {
    backgroundColor: "#E6E6E6"
  },
  ...(selected && {
    backgroundColor: "#E6E6E6"
  })
}))

const FilterProduct = ({ value, onChange }) => {
  const { t } = useTranslation()
  const FILTER_OPTIONS = [
    {
      label: t("lowest_price"),
      search_key: "sortBy",
      search_value: "sale_price"
    },
    {
      label: t("biggest_discount"),
      search_key: "sortBy",
      search_value: "discount_amount",
      direction: "desc"
    },
    {
      label: t("best_selling"),
      search_key: "sortBy",
      search_value: "sales"
    }
  ]
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }
  const handleFilter = filter => () => {
    setAnchorEl(null)
    onChange?.(filter)
  }

  const valueOption = React.useMemo(() => {
    return FILTER_OPTIONS.find(item => item.search_value === value)
  }, [value])

  return (
    <div>
      <Stack
        sx={{
          gap: "16px",
          "& .svg-filter-mobile": {
            display: {
              xs: "flex",
              md: "none"
            }
          },
          "svg ": {
            strokeWidth: 1.5
          }
        }}
        alignItems={"center"}
        alignContent="center"
      >
        <FilterButton
          minHeight={32}
          height={32}
          label={
            <Stack
              sx={{
                "svg ": {
                  strokeWidth: 1.5
                },
                "& .svg-arrow-down ": {
                  transform: open ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s"
                }
              }}
              spacing={0.5}
            >
              <Typography
                variant="body1"
                component="p"
                sx={{
                  fontSize: 12,
                  whiteSpace: "nowrap",
                  lineHeight: "25px"
                }}
              >
                {valueOption?.label || FILTER_OPTIONS[0].label}
              </Typography>
              <Icons className="svg-arrow-down" name="arrow-down" />
            </Stack>
          }
          onClick={handleClick}
        />
      </Stack>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        MenuListProps={{
          "aria-labelledby": "basic-button"
        }}
        sx={{
          ".MuiPaper-root": {
            minWidth: 260,
            padding: "0px",
            margin: "0px",
            borderRadius: "8px",
            boxShadow: "4px 0px 32px -2px rgba(16, 24, 40, 0.08)",
            marginTop: "8px",
            "& .MuiList-root": {
              padding: "0px"
            }
          }
        }}
      >
        {FILTER_OPTIONS.map((item, index) => (
          <StyledItem
            key={index}
            selected={value === item.search_value}
            onClick={handleFilter({
              key: item.search_key,
              value: item.search_value,
              direction: item.direction ?? "asc"
            })}
          >
            {item.label}
          </StyledItem>
        ))}
      </Menu>
    </div>
  )
}

export default FilterProduct
